module.exports = "<svg id=\"ec3d07c9-51e7-4de5-a694-dbba83765cf6\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>facebook</title><circle class=\"icon-background\" cx=\"25\" cy=\"25\" r=\"24.5\"></circle><path class=\"icon-fill\" d=\"M27.3,39.52V26.29h1.53c.84,0,1.68,0,2.52,0,.13,0,.36-.16.38-.27.23-1.61.43-3.23.65-4.9h-5c0-1.43-.08-2.8,0-4.17A1.57,1.57,0,0,1,29,15.41c.78-.08,1.58-.07,2.37-.09h1.11V10.7c-.25,0-.49-.08-.74-.09a16.09,16.09,0,0,0-5.56.22A5.78,5.78,0,0,0,22,16c-.1,1.48-.07,3-.1,4.46,0,.19,0,.37,0,.61H17.49v5.17h4.38V39.49Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 496
// module chunks = 1